import { useEffect, useState } from 'preact/hooks';
import { getLang, onLangChange, type Lang } from '../i18n';

/** Re-render the caller (and, through it, its subtree) when the language changes. */
export function useLang(): Lang {
  const [lang, setLang] = useState<Lang>(getLang());
  useEffect(() => onLangChange(setLang), []);
  return lang;
}

/** Delay a rapidly changing value (search box) without extra dependencies. */
export function useDebounced<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    if (value === debounced) return;
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs, debounced]);

  return debounced;
}
